module.exports = __webpack_public_path__ + "img/position.64ba59dc.svg";